import { useEffect } from 'react';
import { remoteConfigManager } from 'app/services/RemoteConfigManager';

export const useRemoteConfigSession = () => {
  useEffect(() => {
    remoteConfigManager.init();
  }, []);
};
